import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { setClass, useViewModel } from '@utils';
import { isMobile } from 'react-device-detect';
import { ProfileViewModel } from '@views';
import { Autocomplete } from '../autocomplete';
import { EmailsList } from '../emailList';
import { Input } from '../input';
import { Switch } from '../switch';
import '../../styles/components/profileTabs.scss';
import '../../styles/components/profileDetailsTab.scss';

export const ProfileDetailsTab: FC = observer(() => {
  const profileViewModel = useViewModel(ProfileViewModel);
  const onChangeTimeZone = (id: number) => profileViewModel.setTimeZone(profileViewModel.useLocalTimeZone, id);

  return (
    <div className={setClass(isMobile && 'mobile-wrapper')}>
      <h4 className="advanced-info">Должность</h4>
      <div className={setClass('profile-detail-input-wrapper', isMobile && 'mobile')}>
        <Input variant="square" value={profileViewModel.profileInfo.position} disabled />
      </div>
      <h4 className="advanced-info">Часовой пояс</h4>
      <div className={setClass('profile-detail-input-wrapper', isMobile && 'mobile')}>
        <Autocomplete
          disableClearable
          disabled={profileViewModel.useLocalTimeZone}
          options={profileViewModel.timeZones}
          height={36}
          className="profile-detail-input"
          placeholder="Выберите часовой пояс"
          value={profileViewModel.timeZoneId}
          onChange={onChangeTimeZone}
          getOptionLabel={profileViewModel.getTimeZoneLabel}
        />
      </div>
      <div className="use-local-timezone-setting">
        <Switch
          checked={profileViewModel.useLocalTimeZone}
          onChange={profileViewModel.switchUseLocalTimeZone}
        />
        <label>Автоматически определять часовой пояс</label>
      </div>
      <h4 className="advanced-info">Электронная почта (по умолчанию)</h4>
      <EmailsList />
    </div>
  );
});
